import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { FeedbackRequest } from '../models/IFeedback';
import { environment } from '../environment/environment';

class FeedbackService {
  private static instance: FeedbackService;

  private constructor() {}

  public static getInstance(): FeedbackService {
    if (!FeedbackService.instance) {
      FeedbackService.instance = new FeedbackService();
    }
    return FeedbackService.instance;
  }

  public submitFeedback = async (
    sessionId: string,
    feedback: FeedbackRequest
  ): Promise<{}> => {
    try {
      const axiosConfig: AxiosRequestConfig = {
        headers: {
          'TenantAlias':  environment.tenantAlias,
        },
      };

      const response: AxiosResponse<{}> = await axios.post(
        `${environment.controlServerEndpoint}/session/feedback/${sessionId}`,
        feedback,
        axiosConfig
      );
      return response.data;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  };
}

export default FeedbackService.getInstance();